
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import TableTreeColumn from '../../../../components/table-tree-column'
	import fa from "element-ui/src/locale/lang/fa";
	import AddOrUpdate from "./menu-add-or-update.vue"
	@Component({
		name: 'sbgl',
		components:{
			AddOrUpdate:AddOrUpdate,
			TableTreeColumn:TableTreeColumn
		}
	})

	export default class sbgl extends Vue {
		addOrUpdateVisible=false
		loading: boolean = false;
		menuList=[];
		created() {
			this.getDataList();
		}
		getDataList() {
			this.$request({
				url: '/bjba/sys/menu/list',
				method: 'get'
			}).then(response => {
				console.log('aaaaaaaaaaaaaa')
				this.menuList = this.treeDataTranslate(response.data.data, 'menuId', 'parentId', 'childrens')
					})
					.catch(error => {
						console.log(error)
					});
		}
		addOrUpdateHandle (id) {
			this.addOrUpdateVisible = true
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id)
			})
		}
		// 删除
		deleteHandle (id) {
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/sys/menu/delete/${id}`,
					method: 'get'
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.getDataList()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
		/**
		 * 树形数据转换
		 * @param {*} data list数据
		 * @param {*} id 主键ID
		 * @param {*} pid 上级ID
		 * @param childrenKey 子list数据的key
		 */
		treeDataTranslate (data, id = 'id', pid = 'parentId', childrenKey = 'children') {
			let res = []
			let temp = {}
			for (let i = 0; i < data.length; i++) {
				temp[data[i][id]] = data[i]
			}
			for (let k = 0; k < data.length; k++) {
				if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
					if (!temp[data[k][pid]][childrenKey]) {
						temp[data[k][pid]][childrenKey] = []
					}
					if (!temp[data[k][pid]]['_level']) {
						temp[data[k][pid]]['_level'] = 1
					}
					data[k]['_level'] = temp[data[k][pid]]._level + 1
					temp[data[k][pid]][childrenKey].push(data[k])
				} else {
					res.push(data[k])
				}
			}
			return res
		}
	}
